const LegendInfo = ({ config }) => {
  const { colorMeaning, colors, values } = config
  return (
    <div className='flex gap-3 mt-3'>
      {colorMeaning.map((meaning, index) => (
        <div key={index} className='flex flex-col justify-center gap-2'>
          <div className='mb- text-[7px] '>{meaning}</div>
          <div
            className='w-7 h-5 rounded-lg '
            style={{ backgroundColor: colors[index] }}
          />
          {config.title === 'AQI'
            ? index + 1
            : index < values.length - 1 && (
              <div className='mb-1 text-[6px]'>
                {config.title === 'AQI' ? `${values[index]}` : `${values[index]} - ${values[index + 1]}`}
              </div>
            )}
        </div>
      ))}
    </div>
  )
}

export default LegendInfo
